import { API } from "../utils";

export const uploadOrganizationMedia = async ({
  params,
  body,
  onUploadProgress,
}) => {
  const response = API.post(`/organization/media`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    timeout: 120000,
  });
  const data = await response;
  return data;
};

export const deleteOrganizationMedia = async ({ params }) => {
  const response = API.delete(`/organization/media/${params.media}`);
  const data = await response;
  return data;
};

/* Search palette for the task list: looks through subtasks as well as tasks,
 * and carries each row's project so a result means something when the search
 * spans the whole organization. */
export const searchTasks = async ({ params }) => {
  const response = API.get("/organization/tasks/search", { params });
  const data = await response;
  return data;
};

export const getTasks = async ({ params }) => {
  const response = API.get("/organization/tasks", { params });
  const data = await response;
  return data;
};

export const getSubscriptionUsage = async () => {
  const response = API.get("/organization/subscription-usage");
  return response;
};

export const getTrackingTimeSheet = async ({ params }) => {
  const response = API.get("/organization/time-tracking/timesheet", { params });
  const data = await response;
  return data;
};

export const getTrackingTimeSheetExcel = async ({ params }) => {
  const response = API.get('/organization/time-tracking/timesheet/excel/export', { params })
  const data = await response
  return data
}

export const getTransactions = async ({ params }) => {
  const response = API.get('/organization/transactions', { params })
  const data = await response
  return data
}

export const deleteOrganization = async ({ body } = {}) => {
  const response = API.delete("/organization", { data: body });
  const data = await response;
  return data;
};
/* The panel's optional sections. Its own endpoint rather than a field on
 * `updateOrganization`, which needs the whole profile and can demand an OTP. */
export const updateOrganizationModules = async ({ body }) => {
  const response = API.patch(`/organization/modules`, body);
  const data = await response;
  return data;
};

export const getProjectImports = async () => {
  const response = API.get("/organization/project-imports");
  return response;
};

export const previewProjectImport = async ({ body, onUploadProgress }) => {
  const response = API.post("/organization/project-imports/preview", body, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
    timeout: 120000,
  });
  return response;
};

export const getProjectImport = async ({ params }) => {
  const response = API.get(`/organization/project-imports/${params.uuid}`);
  return response;
};

export const commitProjectImport = async ({ params, body }) => {
  const response = API.post(
    `/organization/project-imports/${params.uuid}/commit`,
    body,
  );
  return response;
};
